export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Matches a concrete pathname against a route path that may contain :params. */
export function matchesRoutePath(
  routePath: string,
  pathname: string,
): boolean {
  const pattern = routePath
    .split("/")
    .map((segment) =>
      segment.startsWith(":") ? "[^/]+" : escapeRegExp(segment),
    )
    .join("/");
  return new RegExp(`^${pattern}/?$`).test(pathname);
}
